import { memo } from 'react';
import { Outlet } from 'react-router-dom';

import { TopBar } from '@/lib/components';
import { Button, IconSvg } from '@/lib/v2/components';
import { DeleteIcon } from '@/lib/v2/icons/outline';

import { UserData } from '@/src/application/hooks/useUserDataInterface';

export interface AppLayoutProps {
  userData: UserData;
}

const AppLayout = ({ userData }: AppLayoutProps) => {
  const cookieFEC = document.cookie
    .split('; ')
    .find((row) => row.startsWith('FEC='))
    ?.split('=')[1];

  return (
    <>
      <TopBar
        accountId={userData.companyId}
        companyName={userData.companyName}
        email={userData.email}
        name={userData.name}
      />
      {cookieFEC && (
        <Button
          destructive
          className="!h-12 !w-12 rounded-full"
          classNameContainer="fixed bottom-3 left-3 z-[1000]"
          iconLeft={
            <IconSvg
              className="!h-6 !w-6"
              fillColor="white"
              strokeColor="destructive"
              svgComponent={<DeleteIcon />}
            />
          }
          id="delete-commit-id"
          tooltip={`You have an active commit version ${cookieFEC}, to see the latest version remove the FEC cookie.`}
        />
      )}
      <Outlet />
    </>
  );
};

export default memo(AppLayout);
